(function($){
  OH.settings.colsControl = (function(){
    var control = new Object();

    var control = {
      /**
       * c-cols__col系がウィンドウ内に入ってきた場合のアニメーション
       */
      boxVisible: function($parent){
        var colsClassPrefix = $parent.hasClass('c-vcols__col') ? '.c-vcols' : $parent.hasClass('c-cols__col') ? '.c-cols' : 'l-feature__list'; //boxの種類によって親のclass指定わける
        var colsClass = (colsClassPrefix == '.c-vcols' || colsClassPrefix == '.c-cols') ? colsClassPrefix +'__col' : colsClassPrefix +'__item';//thisのクラス再定義で安定化
        var deviceSPMediaQuery = window.matchMedia('(max-width:600px)').matches; //スマホ判別
        var colsModePrefix = !deviceSPMediaQuery? 'is-': 'is-sm'; // クラス取得のためのprefix判別。PCだったらis-X、SPだったらis-smXX。
        var classListArray = $parent[0].classList.toString();//$thisのクラス一覧を取得して文字列に変換
        var regColsNum = new RegExp(colsModePrefix + '[1-9]?[0-9]');//クラスマッチングのための正規表現作成
        var colsNumClass = classListArray.match(regColsNum);//クラスのプレフィックスを取得
        var colsNum = (colsClassPrefix == '.c-vcols' || colsClassPrefix == '.c-cols') ? colsNumClass[0].replace(colsModePrefix, '') : 12 ;//横に並ぶカラム数設定の取得。
        var horizontalColsNumber = 12 / colsNum;//横並びカラムの数取得。
        var selfIndex = $parent.parent(colsClassPrefix).find(colsClass).index($parent);//thisのindex取得
        var delayTime = Math.round(selfIndex % horizontalColsNumber * 1 + 1 ) / 5 + 's';//thisのアニメーションdelayタイムを計算。

        $parent.css({
          'transitionDelay': delayTime,
        });
        
        $(window).on('load scroll',function(){
          var parentPosition = $parent.offset().top - window.innerHeight; //thisの位置
          if($(window).scrollTop() > parentPosition){//whindow内にいるかの判別
            $parent.css({
              'top' : '0px',
              'opacity' : 1,
            });
          }
        });
        
        /**
         * アニメーションがおわったらtransitionDelayを消す処理
         */
        $parent.on('AnimationEnd webkitAnimationEnd', function(){ 
          $parent.css('transitionDelay', '');
        });
      }
    
    
    }
    return control;
	})();
})(jQuery);
